import { useEffect } from "react";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Band } from "@/components/site/Band";
import { Services } from "@/components/site/Services";
import { Donate } from "@/components/site/Donate";
import { Events } from "@/components/site/Events";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { DonateProvider } from "@/components/site/DonateModal";

const useParallax = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    let ticking = false;
    const run = () => {
      const vh = window.innerHeight;
      document.querySelectorAll(".layer[data-speed]").forEach((l) => {
        const sp = parseFloat(l.dataset.speed);
        let y;
        if (l.hasAttribute("data-rel")) {
          const r = l.parentElement.getBoundingClientRect();
          y = Math.max(-90, Math.min(90, (r.top + r.height / 2 - vh / 2) * sp * -0.5));
        } else y = window.scrollY * sp;
        l.style.transform = `translate3d(0,${y.toFixed(1)}px,0)`;
      });
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) { ticking = true; requestAnimationFrame(run); }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    run();
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
};

export default function HomePage() {
  useParallax();
  return (
    <DonateProvider>
    <div className="site" data-testid="home-page">
      <a className="skip" href="#about" data-testid="skip-link">Skip to content</a>
      <Nav />
      <main>
        <Hero />
        <About />
        <Band />
        <Services />
        <Donate />
        <Events />
        <Contact />
      </main>
      <Footer />
    </div>
    </DonateProvider>
  );
}
